/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import NextImage from '@/components/NextImage';
import { useLabels } from '@/hooks/useLabels';
import { View, Text } from '@az/starc-ui';
import styles from './styles.module.scss';

const labelMap = {
  incentivizedReview: 'label_reviews_incentivizedReview',
  verifiedPurchaser: 'label_reviews_verifiedPurchaser',
};

export type ReviewBadgesProps = {
  verifiedPurchase: boolean;
  incentivizedReview: boolean;
};

const icons = {
  gift: '/images/reviews/gift.svg',
  starCircle: '/images/reviews/star-circle.svg',
};

export const ReviewBadges = ({ verifiedPurchase, incentivizedReview }: ReviewBadgesProps) => {
  const labels = useLabels(labelMap);

  return (
    <View className={styles.badgeContainer} attributes={{ 'data-testid': 'badges' }}>
      {verifiedPurchase && (
        <View className={styles.reviewBadge}>
          <NextImage src={icons.starCircle} width={24} height={24} />
          <Text as="span">{labels.verifiedPurchaser}</Text>
        </View>
      )}

      {incentivizedReview && (
        <View className={styles.reviewBadge}>
          <NextImage src={icons.gift} width={24} height={24} />
          <Text as="span">{labels.incentivizedReview}</Text>
        </View>
      )}
    </View>
  );
};
